import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import InsuranceContract from 'components/InsuranceContract';
import ActivateInsuranceContract from 'components/ActivateInsuranceContract';
import ContractCancel from 'components/ContractCancel';

import { connect } from 'react-redux';
import { findContract, cancelContract } from '../actions/insuranceContracts';
import { findDevice } from '../actions/devices';
import { findInsurancePlan } from '../actions/insurancePlans';
import { fetchDeviceByContract } from '../actions/insuranceDevices';
import {
  getContract,
  getDevicesByContract,
  getSubmitStatus,
  getDeviceSpecs,
  getInsurancePlan,
} from 'reducers';

export class ViewContract extends Component {
  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) {
    const { match, devices } = this.props;
    if (
      prevProps.match.params.id &&
      match.params.id &&
      prevProps.match.params.id !== match.params.id
    ) {
      this.fetchData();
    }

    if (
      (!prevProps.devices.length && devices.length) ||
      (prevProps.devices.length &&
        devices.length &&
        prevProps.devices[0].id !== devices[0].id)
    ) {
      this.props.findDevice(devices[0].device_specs);
      this.props.findInsurancePlan(devices[0].plan);
    }
  }

  fetchData = () => {
    this.props.findContract(this.props.match.params.id);
    this.props.fetchDeviceByContract(this.props.match.params.id);
  };

  render() {
    const {
      contract,
      cancelContract,
      findContract,
      devices,
      saveStatus,
      deviceSpecs,
      insurancePlan,
    } = this.props;

    if (!contract) {
      return <div>Loading</div>;
    } else {
      const isCancelled = contract.status === 'cancelled';
      const isActive = contract.status === 'active';
      return (
        <div>
          <InsuranceContract
            contract={contract}
            devices={devices}
            deviceSpecs={deviceSpecs}
            insurancePlan={insurancePlan}
          />
          {!isCancelled && (
            <React.Fragment>
              {!isActive && (
                <ActivateInsuranceContract
                  id={contract.id}
                  onSuccess={findContract}
                />
              )}
              <ContractCancel
                id={contract.id}
                onSubmit={(values) => cancelContract(contract.id, values)}
                saveStatus={saveStatus}
              />
              <br />
              <br />
              <Link
                className="btn btn-default mar-r"
                to={`/device-protection/contracts/${contract.id}/add-device`}
              >
                Add Device
              </Link>
              <Link
                className="btn btn-default"
                to={`/device-protection/contracts/${contract.id}/update`}
              >
                Update Contract
              </Link>
            </React.Fragment>
          )}
        </div>
      );
    }
  }
}

const mapStateToProps = (
  state,
  {
    match: {
      params: { id },
    },
  },
) => {
  const devices = getDevicesByContract(state, id);
  const deviceSpecs =
    devices && devices.length
      ? getDeviceSpecs(state, devices[0].device_specs)
      : undefined;
  const insurancePlan =
    devices && devices.length
      ? getInsurancePlan(state, devices[0].plan)
      : undefined;

  return {
    contract: getContract(state, id),
    saveStatus: getSubmitStatus(state, 'contractCancel'),
    devices,
    deviceSpecs,
    insurancePlan,
  };
};

const mapDispatchToProps = {
  findContract,
  cancelContract,
  fetchDeviceByContract,
  findDevice,
  findInsurancePlan,
};

export const ConnectedViewContract = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ViewContract);

export default ConnectedViewContract;
